/**
 * 保存ボタンの有効・無効をコントロールします。
 *
 * 使用例:
 * 1. エラーが発生し、保存ボタンを無効にする（アイコン付き）:
 *    submitButtonControl('hasError', true);
 *
 * 2. エラーが解消され、保存ボタンを有効にする:
 *    submitButtonControl('submittable');
 *
 * @param {String} type 'hasError' （エラーありで送信不可） | 'submittable' （送信可）
 * @param {Boolean} withIcon アイコンを表示するかどうか。デフォルトはtrue。
 */
export function submitButtonControl(type, withIcon = true) {
    mtappVars.__system = mtappVars.__system || {};
    mtappVars.__system.submitButtonNodeList = mtappVars.__system.submitButtonNodeList || [];
    mtappVars.__system.submitStatusNode = mtappVars.__system.submitStatusNode || null;
    mtappVars.__system.submitButtonControlTargetList = mtappVars.__system.submitButtonControlTargetList || [];

    const system = mtappVars.__system;
    if (system.submitButtonNodeList.length === 0) {
        system.submitButtonNodeList = document.querySelectorAll('[type="submit"].btn-primary');
    }
    if (system.submitStatusNode === null) {
        system.submitStatusNode = document.querySelector('[name="status"]');
    }

    // SVGアイコンのHTML部分
    const errorIconHTML = `<svg title="Stop" role="img" class="mt-icon--inverse mt-icon--sm ms-2">
        <use xlink:href="${mtappVars.static_path}images/sprite.svg#ic_error"></use>
    </svg>`;

    switch (type) {
        case 'init':
            break;
        case 'hasError':
            if (
                system.submitButtonNodeList ||
                (system.submitButtonControlTargetList.length > 0 &&
                    system.submitButtonControlTargetList.includes(system.submitStatusNode.value))
            ) {
                system.submitButtonNodeList.forEach((button) => {
                    button.disabled = true;
                    if (!button.classList.contains('mtapp-has-error') && withIcon) {
                        button.classList.add('mtapp-has-error');
                        button.insertAdjacentHTML('beforeend', errorIconHTML);
                    }
                });
            }
            break;
        case 'submittable':
            if (system.submitButtonNodeList) {
                system.submitButtonNodeList.forEach((button) => {
                    button.disabled = false;
                    const svgElements = button.querySelectorAll('svg');
                    svgElements.forEach((svg) => svg.remove());
                    button.classList.remove('mtapp-has-error');
                });
            }
            break;
    }
}
